import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

const SmallAndSubtle = styled(Box)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray['500']};
`;

export default SmallAndSubtle;
